module.exports = __webpack_public_path__ + "img/visa-blue.169c076d.png";